// extracted by mini-css-extract-plugin
export default {"title":"LoadingBlock_title__qlB+w","container":"LoadingBlock_container__fRK3m"};